import {
  Grid2,
  Paper,
  Divider,
  AppBar,
  Button,
  Toolbar,
  Drawer,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { Link, NavLink } from 'react-router-dom';
import { ArchBuilder } from './ArchBuilder';
import React, { JSX, useContext } from 'react';
import { LanguageContext } from '../main/contexts/LanguageContext';
import {
  ElementAttribute,
  ElementCard,
  formatText,
} from '../main/components/ElementCard/ElementCard';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import ElementCardGroup from '../main/components/ElementCard/ElementCardGroup';
import { FaStackOverflow } from 'react-icons/fa';
import DoubleDrawer from '../main/components/DoubleDrawer';
import { ThemeContext } from '../main/contexts/ThemeContext';
import ElementCardButton from '../main/components/ElementCard/ElementCardButton';

class ArchBuilderPC implements ArchBuilder {
  Home = (imageSrc: string): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <Grid2 container className="home-page montmelo">
        <Box className="vertical-divider" />

        <Box className="central-square from-behind">
          <img src={imageSrc} alt="Welcome" className="center-icon" />
          <h1 className="welcome-text bouncer">{t('welcome')}</h1>
        </Box>

        <Grid2 container columns={100} className="full">
          <Grid2 size={34} className="home-left-color">
            <Paper
              elevation={4}
              className="home-paper home-paper-left from-above bouncer">
              <span />
              <h1>{t('home/name')}</h1>
              <h2>{t('home/position')}</h2>
              <Divider className="horizontal-divider" />
              <p>{t('home/my_description')}</p>
            </Paper>
          </Grid2>

          <Grid2 size={16} height={'100%'}>
            <Box className="home-left-color" />
          </Grid2>
          <Grid2 size={16} height={'100%'}>
            <Box className="home-right-color" />
          </Grid2>

          <Grid2 size={34} className="home-right-color">
            <Paper
              elevation={4}
              className="home-paper home-paper-right from-above bouncer">
              <span />
              <h1>{t('home/what_you_can_see_here')}</h1>
              <Divider className="horizontal-divider" />
              <ul>
                <li>
                  <strong>
                    <u>
                      <Link to="/background" className="home-link">
                        {t('home/background_tag')}
                      </Link>
                    </u>
                    {': '}
                  </strong>
                  {t('home/background_line')}
                </li>
                <li>
                  <strong>
                    <u>
                      <Link to="/projects" className="home-link">
                        {t('home/projects_tag')}
                      </Link>
                    </u>
                    {': '}
                  </strong>
                  {t('home/projects_line')}
                </li>
                <li>
                  <strong>
                    <u>
                      <Link to="/works" className="home-link">
                        {t('home/works_tag')}
                      </Link>
                    </u>
                    {': '}
                  </strong>
                  {t('home/works_line')}
                </li>
                <li>
                  <strong>
                    <u>
                      <Link to="/about-me" className="home-link">
                        {t('home/aboutme_tag')}
                      </Link>
                    </u>
                    {': '}
                  </strong>
                  {t('home/aboutme_line')}
                </li>
                <li>
                  <strong>
                    <u>
                      <Link to="/contact-me" className="home-link">
                        {t('home/contactme_tag')}
                      </Link>
                    </u>
                    {': '}
                  </strong>
                  {t('home/contactme_line')}
                </li>
                <li>
                  <span>{t('home/settings_tag')}</span>
                  {': '}
                  {t('home/settings_line')}
                </li>
              </ul>
            </Paper>
          </Grid2>
        </Grid2>
      </Grid2>
    );
  };
  Background = (
    elements1: ElementAttribute[],
    elements2: ElementAttribute[],
    elements3: ElementAttribute[],
    elements4: ElementAttribute[],
    elements5: ElementAttribute[],
    getTurn: () => boolean,
  ): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <div className={`fullUnder tabs-page gradu`}>
        <Box className={'tabs-color'} />
        <div className="courtesy">
          <ElementCardGroup title={t('group_names/working')}>
            <ElementCard
              title={t('background/developer/title')}
              isTitleLeft={getTurn()}
              attributes={elements1}
            />
            <ElementCard
              title={t('background/teacher/title')}
              isTitleLeft={getTurn()}
              attributes={elements2}
            />
          </ElementCardGroup>
          <ElementCardGroup title={t('group_names/studying')}>
            <ElementCard
              title={t('background/masters/title')}
              isTitleLeft={getTurn()}
              attributes={elements3}
            />
            <ElementCard
              title={t('background/college/title')}
              isTitleLeft={getTurn()}
              attributes={elements4}
            />
            <ElementCard
              title={t('background/bach/title')}
              isTitleLeft={getTurn()}
              attributes={elements5}
            />
          </ElementCardGroup>
        </div>
      </div>
    );
  };
  Projects = (
    elements1: ElementAttribute[],
    elements2: ElementAttribute[],
    elements3: ElementAttribute[],
    elements4: ElementAttribute[],
    elements5: ElementAttribute[],
    elements6: ElementAttribute[],
    elements7: ElementAttribute[],
    elements8: ElementAttribute[],
    elements9: ElementAttribute[],
    elements10: ElementAttribute[],
    getTurn: () => boolean,
  ): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <div className={`fullUnder tab-page karting`}>
        <Box className={'tabs-color'} />
        <div className="courtesy">
          <ElementCardGroup title={t('group_names/after_college')}>
            <ElementCard
              title={t('projects/mkmudae/title')}
              imageUrl="images/elementlogos/mkmudae.png"
              isTitleLeft={getTurn()}
              attributes={elements10}
            />
            <ElementCard
              title={t('projects/walletmaster/title')}
              imageUrl="images/elementlogos/walletmaster.png"
              isTitleLeft={getTurn()}
              attributes={elements1}
            />
            <ElementCard
              imageUrl="images/elementlogos/kustomp5r.png"
              title={t('projects/kustom/title')}
              isTitleLeft={getTurn()}
              attributes={elements4}
            />
          </ElementCardGroup>
          <ElementCardGroup title={t('group_names/final_projects')}>
            <ElementCard
              title={t('projects/tfg/title')}
              imageUrl="images/elementlogos/commanager.png"
              isTitleLeft={getTurn()}
              attributes={elements2}
            />
            <ElementCard
              title={t('projects/tfm/title')}
              imageUrl="images/elementlogos/gloomreaper.png"
              isTitleLeft={getTurn()}
              attributes={elements3}
            />
          </ElementCardGroup>
          <ElementCardGroup title={t('group_names/during_college')}>
            <ElementCard
              title={t('projects/fons/title')}
              imageUrl="images/elementlogos/fons.png"
              isTitleLeft={getTurn()}
              attributes={elements5}
            />
            <ElementCard
              title={t('projects/xcelsona/title')}
              imageUrl="images/elementlogos/xcelsona.png"
              isTitleLeft={getTurn()}
              attributes={elements6}
            />
            <ElementCard
              title={t('projects/oxo/title')}
              isTitleLeft={getTurn()}
              attributes={elements7}
            />
            <ElementCard
              title={t('projects/snakemrv/title')}
              isTitleLeft={getTurn()}
              attributes={elements8}
            />
            <ElementCard
              title={t('projects/cserg/title')}
              isTitleLeft={getTurn()}
              attributes={elements9}
            />
          </ElementCardGroup>
        </div>
      </div>
    );
  };
  Works = (
    elements1: ElementAttribute[],
    elements2: ElementAttribute[],
    elements3: ElementAttribute[],
    elements4: ElementAttribute[],
    elements5: ElementAttribute[],
    getTurn: () => boolean,
  ): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <div className={`fullUnder tab-page theworks`}>
        <Box className={'tabs-color'} />
        <div className="courtesy">
          <ElementCardGroup title={t('group_names/design')}>
            <ElementCard
              imageUrl="images/elementlogos/hyperbole.png"
              title={t('works/hyperbole/title')}
              isTitleLeft={getTurn()}
              attributes={elements5}
            />
            <ElementCard
              imageUrl="images/elementlogos/epochalypse.png"
              title={t('works/arcweave/title')}
              isTitleLeft={getTurn()}
              attributes={elements1}
            />
            {/*
          <ElementCard
            title={t('works/srpg/title')}
              isTitleLeft={getTurn()}
            attributes={elements3}
          />
          <ElementCard
            title={t('works/mkparty/title')}
              isTitleLeft={getTurn()}
            attributes={elements4}
          />
          */}
          </ElementCardGroup>
          <ElementCardGroup title={t('group_names/novels')}>
            <ElementCard
              title={t('works/novelamk/title')}
              imageUrl="images/elementlogos/superstandkart.png"
              isTitleLeft={getTurn()}
              attributes={elements2}
            />
          </ElementCardGroup>
        </div>
      </div>
    );
  };
  AboutMe = (
    elements1: ElementAttribute[],
    elements2: ElementAttribute[],
    elements3: ElementAttribute[],
    elements4: ElementAttribute[],
    elements5: ElementAttribute[],
    elements6: ElementAttribute[],
    getTurn: () => boolean,
  ): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <div className={`fullUnder tab-page kartingvspc`}>
        <Box className={'tabs-color'} />
        <div className="courtesy">
          <ElementCardGroup title={t('group_names/skills')}>
            <ElementCard
              title={elements2[0].name}
              isTitleLeft={getTurn()}
              attributes={elements2}
            />
            <ElementCard
              title={elements3[0].name}
              isTitleLeft={getTurn()}
              attributes={elements3}
            />
            <ElementCard
              title={elements5[0].name}
              isTitleLeft={getTurn()}
              attributes={elements5}
            />
          </ElementCardGroup>
          <ElementCardGroup title={t('group_names/personal')}>
            <ElementCard
              title={elements1[0].name}
              isTitleLeft={getTurn()}
              attributes={elements1}
            />
            <ElementCard
              title={elements4[0].name}
              isTitleLeft={getTurn()}
              attributes={elements4}
            />
            <ElementCard
              title={elements6[0].name}
              isTitleLeft={getTurn()}
              attributes={elements6}
            />
          </ElementCardGroup>
        </div>
      </div>
    );
  };
  ContactMe = (listIconSize: number, themeIconColor: string): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <div className="fullUnder tab-page thecontact contact-page">
        <Box className="tabs-color" />
        <Box className="vertical-divider" />
        <div className="contact-square">
          <span />
          <div className="contact-title bouncer">
            <p>{t('contact_me_page/shall_we_talk')}</p>
            <Divider className="horizontal-divider" />
          </div>
          {/* Gmail */}
          <Box className="contact-list-item">
            <EmailIcon style={{ fontSize: listIconSize, color: themeIconColor }} />
            <p>{t('contact_me_page/mail')}</p>
          </Box>

          {/* LinkedIn */}
          <Box className="contact-list-item">
            <LinkedInIcon
              style={{ fontSize: listIconSize, color: themeIconColor }}
            />
            <a
              href="https://www.linkedin.com/in/sergio-juan-roll%C3%A1n-moralejo-320bb7209/"
              target="_blank"
              rel="noopener noreferrer">
              <p>
                <u>{t('contact_me_page/linkedin')}</u>
              </p>
            </a>
          </Box>

          {/* GitHub */}
          <Box className="contact-list-item">
            <GitHubIcon style={{ fontSize: listIconSize, color: themeIconColor }} />
            <a
              href="https://github.com/SergioRollan?tab=repositories"
              target="_blank"
              rel="noopener noreferrer">
              <p>
                <u>{t('contact_me_page/github')}</u>
              </p>
            </a>
          </Box>

          {/* StackOverflow */}
          <Box className="contact-list-item">
            <FaStackOverflow
              style={{ fontSize: listIconSize, color: themeIconColor }}
            />
            <a
              href="https://stackoverflow.com/users/13506532/s-rollan"
              target="_blank"
              rel="noopener noreferrer">
              <p>
                <u>{t('contact_me_page/stackoverflow')}</u>
              </p>
            </a>
          </Box>
        </div>
      </div>
    );
  };
  TopBar = (open: boolean, setOpen: (a: boolean) => void): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <header className="topbar">
        <AppBar position="fixed" className="appbar">
          <Toolbar className="toolbar">
            <div className="logo">
              <NavLink to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo.png`}
                  alt="Logo"
                  className="logo-img"
                />
              </NavLink>
            </div>
            <nav className="nav">
              <NavLink to="/background" className="nav-item">
                <span />
                {t('my_background')}
              </NavLink>
              <NavLink to="/projects" className="nav-item">
                <span />
                {t('my_projects')}
              </NavLink>
              <NavLink to="/works" className="nav-item">
                <span />
                {t('my_works')}
              </NavLink>
              <NavLink to="/about-me" className="nav-item">
                <span />
                {t('about_me')}
              </NavLink>
              <NavLink to="/contact-me" className="nav-item">
                <span />
                {t('contact_me')}
              </NavLink>
              <Button onClick={() => setOpen(true)}>
                <img
                  height={'25px'}
                  width={'auto'}
                  alt="drawer"
                  src={`${process.env.PUBLIC_URL}/images/menu.png`}
                />
              </Button>
            </nav>
            <DoubleDrawer open={open} setOpen={setOpen} />
          </Toolbar>
        </AppBar>
      </header>
    );
  };
  Drawer = (open: boolean, setOpen: (a: boolean) => void): JSX.Element => {
    const { t, language, setLanguage } = useContext(LanguageContext);
    const { setTheme } = useContext(ThemeContext);
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        className="drawer-tab">
        <Box>
          <Typography variant="h6" className="drawer-header">
            {t('drawer/select_theme')}
          </Typography>
        </Box>

        <Divider className="horizontal-divider" />

        <Box className="drawer-list">
          <Button
            variant="contained"
            className="drawer-button drawer-light"
            onClick={() => setTheme('light')}>
            {t('drawer/theme_light')}
          </Button>
          <Button
            variant="contained"
            className="drawer-button drawer-dark"
            onClick={() => setTheme('dark')}>
            {t('drawer/theme_dark')}
          </Button>
          <Button
            variant="contained"
            onClick={() => setTheme('thief')}
            className="drawer-button drawer-thief">
            {t('drawer/theme_thief')}
          </Button>
        </Box>

        <div className="drawer-courtesy" />

        <Box>
          <Typography variant="h6" className="drawer-header">
            {t('drawer/select_lang')}
          </Typography>
        </Box>

        <Divider className="horizontal-divider" />

        <Box className="drawer-list">
          <Button
            variant="contained"
            className={
              'drawer-button ' +
              (language === 'en' ? 'drawer-en-active' : 'drawer-en')
            }
            onClick={() => setLanguage('en')}>
            {t('drawer/lang_english')}
          </Button>
          <Button
            variant="contained"
            className={
              'drawer-button ' +
              (language === 'es' ? 'drawer-es-active' : 'drawer-es')
            }
            onClick={() => setLanguage('es')}>
            {t('drawer/lang_spanish')}
          </Button>
          <Button
            variant="contained"
            className={
              'drawer-button ' +
              (language === 'ge' ? 'drawer-ge-active' : 'drawer-ge')
            }
            onClick={() => setLanguage('ge')}>
            {t('drawer/lang_german')}
          </Button>
        </Box>
        {/* Footer */}
        <Box
          sx={{
            textAlign: 'center',
            marginTop: '16px',
          }}>
          <Divider className="horizontal-divider" />
          <div className="drawer-courtesy" />
          <Typography variant="body2" color="textSecondary">
            © 2025 {t('name')}
          </Typography>
        </Box>
      </Drawer>
    );
  };
  ElementCard = (
    isTitleLeft: boolean,
    imageUrl: string,
    title: string,
    hasMultipleAttributes: boolean,
    handleButtonClick: (
      content: string,
      ref: string | undefined,
      href: string | undefined,
      index: number,
    ) => void,
    attributes: ElementAttribute[],
    openIndex: number,
    activeContent: string,
    activeRef: string,
    activeHref: string,
  ): JSX.Element => {
    const { t } = useContext(LanguageContext);
    return (
      <Paper className="element-card-ext">
        <Grid2
          container
          spacing={2}
          direction={isTitleLeft ? 'row' : 'row-reverse'}
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}>
          <Grid2
            sx={{
              flex: '1 1 20%',
            }}>
            {imageUrl && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '10px',
                }}>
                <img
                  src={imageUrl}
                  alt={title}
                  className="bouncer"
                  style={{
                    width: '33%',
                    maxHeight: 'auto',
                    borderRadius: '8px',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            )}
            <Typography variant="h5" className="bouncer element-card-title">
              {title}
            </Typography>
          </Grid2>

          <Divider
            orientation="vertical"
            flexItem
            sx={{
              margin: '0 10px',
            }}
          />

          <Grid2
            container
            spacing={2}
            direction={isTitleLeft ? 'row' : 'row-reverse'}
            sx={{
              flex: '1 1 75%',
              display: 'flex',
            }}>
            {hasMultipleAttributes && (
              <Grid2
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transformStyle: 'preserve-3d',
                    gap: '10px',
                  }}>
                  {attributes.map((attr, index) => (
                    <ElementCardButton
                      index={index}
                      isTitleLeft={isTitleLeft}
                      isOpen={openIndex === index}
                      onClick={() =>
                        handleButtonClick(attr.content, attr.ref, attr.href, index)
                      }
                      content={attr.name}
                    />
                  ))}
                </Box>
              </Grid2>
            )}

            <Grid2
              className="element-card-content-box"
              sx={{
                flex: hasMultipleAttributes ? '1 1 70%' : '1 1 100%',
              }}>
              <Typography
                variant="body1"
                className="element-card-content"
                sx={{
                  marginY: hasMultipleAttributes ? '0' : '4%',
                }}>
                {formatText(activeContent || '')}
                {activeRef !== undefined && activeHref !== undefined ? (
                  <a href={activeHref} target="_blank">
                    <u>{activeRef}</u>
                  </a>
                ) : (
                  ''
                )}
              </Typography>
            </Grid2>
          </Grid2>
        </Grid2>
      </Paper>
    );
  };
}

export { ArchBuilderPC };
